module.exports = __webpack_public_path__ + "static/media/14.700e40bc.png";